import React from "react";
import { Card } from "../modules/Settings/Regions";

export function RegionCardPage(props) {
  return <Card {...props} />;
}
